export const classes = {
  optionsIcon: 'text-taupe-2 dark:text-mauve-2',
};
